import { useEffect } from "react";
import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

//#region src/components/auto-scrolltop/AutoScrolltop.tsx
const scrollToTop = () => window.scroll({
	top: 0,
	left: 0,
	behavior: "instant"
});
const AutoScrolltop = () => {
	const { key } = useLocation();
	useEffect(() => {
		scrollToTop();
	}, [useNavigationType() === NavigationType.Pop, key]);
	useEffect(() => {
		if ("scrollRestoration" in history) history.scrollRestoration = "manual";
		window.addEventListener("load", function() {
			setTimeout(scrollToTop, 0);
		});
	}, []);
	return null;
};

//#endregion
export { AutoScrolltop };